import { Injectable, inject } from '@angular/core';
import { AppConfig } from '@mkp/shared/util-app-config';
import { WorkspaceRouteService } from './workspace-route.helper';

export interface RouteRedirection {
  from: string | RegExp;
  to: string;
}

@Injectable({
  providedIn: 'root',
})
export class AccountProtectionService {
  public workspaceRoute = inject(WorkspaceRouteService);

  private unAuthorizedRoute: RouteRedirection[] = [
    // Redirect on account deselection for the whole creation process. It used to be one rule on
    // the `/vacancy/publish/` prefix; the flow is now split across /vacancy/new and
    // /vacancy/:id/publish, and the id in the middle is why the second one needs a pattern.
    {
      from: `/${AppConfig.routes.vacancy}/${AppConfig.routes.new}`,
      to: AppConfig.routes.vacancies,
    },
    {
      from: new RegExp(`/${AppConfig.routes.vacancy}/[^/]+/${AppConfig.routes.publish}`),
      to: AppConfig.routes.vacancies,
    },
    {
      from: `/${AppConfig.routes.user}/${AppConfig.routes.new}`,
      to: `/${AppConfig.routes.user}/${AppConfig.routes.list}`,
    },
    {
      from: `/${AppConfig.routes.credits}/${AppConfig.routes.productsOptions}`,
      to: AppConfig.routes.vacancies,
    },
  ];

  checkCurrentUrl(url: string) {
    const unAuthorizedRoute = this.unAuthorizedRoute.find(({ from }) =>
      typeof from === 'string' ? url.includes(from) : from.test(url)
    );

    if (unAuthorizedRoute) {
      this.workspaceRoute.navigate([unAuthorizedRoute.to]);
    }
  }
}
